import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { StoreEmployee } from "@/models/storeModel";
import { ScrollArea } from "@/components/ui/scroll-area";

interface StaffSelectorProps {
  employees: StoreEmployee[];
  selectedStaffId: string;
  onStaffSelect: (staffId: string) => void;
  disabled?: boolean;
}

export function StaffSelector({
  employees,
  selectedStaffId,
  onStaffSelect,
  disabled = false,
}: StaffSelectorProps) {
  return (
    <Select
      value={selectedStaffId}
      onValueChange={onStaffSelect}
      disabled={disabled}
    >
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder="Select employee" />
      </SelectTrigger>
      <SelectContent>
        <ScrollArea className="max-h-[200px]">
          {employees.map((employee) => (
            <SelectItem key={employee.id} value={employee.id}>
              {`${employee.firstName} ${employee.lastName}`}
            </SelectItem>
          ))}
        </ScrollArea>
      </SelectContent>
    </Select>
  );
}
